import { resourceState, resourceMutations } from '@/store/utils/resource';
import { ACCOUNT_SUBSCRIPTION_ORDERS } from '@/store/entities/schema_types';
import { accountSubscriptionSubscriptionOrdersClient as client } from '@/api/clients';

export default {
  namespaced: true,

  state: resourceState(),

  mutations: resourceMutations,

  actions: {
    async load(ctx, { accountSubscriptionUuid, params = {} }) {
      try {
        const response = await client.list(accountSubscriptionUuid, { params });

        const { data, meta, links } = response.data;

        const accountSubscriptionOrderIds = await ctx.dispatch(
          'entities/persistEntities',
          { type: ACCOUNT_SUBSCRIPTION_ORDERS, data },
          { root: true }
        );

        ctx.commit('setIds', accountSubscriptionOrderIds);
        ctx.commit('setMeta', meta);
        ctx.commit('setLinks', links);

        return Promise.resolve({ accountSubscriptionOrderIds });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },

    async store(ctx, { accountSubscriptionUuid, formData }) {
      try {
        const response = await client.store(accountSubscriptionUuid, formData);

        const { data } = response.data;

        const accountSubscriptionOrderId = await ctx.dispatch(
          'entities/persistEntities',
          { type: ACCOUNT_SUBSCRIPTION_ORDERS, data },
          { root: true }
        );

        ctx.commit('setIds', [...ctx.state.ids, accountSubscriptionOrderId]);

        return Promise.resolve({ accountSubscriptionOrderId });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },

    async renew(ctx, { accountSubscriptionUuid, formData }) {
      try {
        const response = await client.renew(accountSubscriptionUuid, formData);

        const { data } = response.data;

        const accountSubscriptionOrderId = await ctx.dispatch(
          'entities/persistEntities',
          { type: ACCOUNT_SUBSCRIPTION_ORDERS, data },
          { root: true }
        );

        ctx.commit('setIds', [...ctx.state.ids, accountSubscriptionOrderId]);

        return Promise.resolve({ accountSubscriptionOrderId });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
  },

  getters: {
    accountSubscriptionOrders: ({ ids }, getters, { entities }) =>
      ids.map((id) => entities.accountSubscriptionOrders.byId[id]),
  },
};
